<div class="container">
  <div class="row">
    <div class="col-sm-9 col-md-7 col-lg-4 col-md-offset-4 mx-auto mb-20">
      <div class="login-container">
        <div class="title">
          <h1 class="title-heading">{{ title | translate }}</h1>
        </div>
        <div class="login-form">
          <form id="forgetPassForm" *ngIf="codeSent === false" [formGroup]="forgetPassForm">
            <div class="form-group">
              <input type="email" placeholder="Email *" class="primary" formControlName="email" />
              <div
                *ngIf="forgetPassForm.controls.email.invalid && forgetPassForm.controls.email.touched"
                class="invalid-message"
              >
                {{ 'A valid e-mail is required' | translate }}
              </div>
            </div>
            <div class="form-group alert alert-danger" *ngIf="errorMessage">
              {{ errorMessage }}
            </div>
          </form>
          <form id="changePassForm" *ngIf="codeSent === true" [formGroup]="changePassForm">
            <div class="form-group">
              <input
                type="email"
                placeholder="Email *"
                class="primary"
                formControlName="email"
                autocomplete="username"
              />
              <div
                *ngIf="changePassForm.controls.email.invalid && changePassForm.controls.email.touched"
                class="invalid-message"
              >
                {{ 'A valid e-mail is required' | translate }}
              </div>
            </div>
            <div class="form-group">
              <input type="text" placeholder="Code *" class="primary" formControlName="code" autocomplete="off" />
              <div
                *ngIf="changePassForm.controls.code.invalid && changePassForm.controls.code.touched"
                class="invalid-message"
              >
                {{ 'Code is required' | translate }}
              </div>
            </div>

            <div class="form-group">
              <input
                type="password"
                placeholder="Password *"
                class="primary"
                formControlName="password"
                autocomplete="current-password"
              />
              <div
                *ngIf="changePassForm.controls.password.invalid && changePassForm.controls.password.touched"
                class="invalid-message"
              >
                {{ 'Password is required' | translate }}
              </div>
            </div>
            <div class="form-group alert alert-danger" *ngIf="errorMessage">
              {{ errorMessage }}
            </div>
          </form>
          <div class="d-flex submit-button-container">
            <button
              *ngIf="codeSent === true && passChanged === false"
              class="btn primary login-btn"
              (click)="onChangePass()"
              [disabled]="changePassForm.invalid"
            >
              {{ 'Change Password' | translate }}
            </button>
            <button
              *ngIf="codeSent === false && passChanged === false"
              class="btn primary login-btn"
              (click)="onSentCode()"
              [disabled]="forgetPassForm.invalid"
            >
              {{ 'Send Code' | translate }}
            </button>
            <button *ngIf="passChanged === true" class="btn primary login-btn" (click)="openPopup(true)">
              {{ 'Click here to login' | translate }}
            </button>
          </div>
          <div class="login-link text-right mt-2" *ngIf="passChanged !== true">
            <a class="link primary" (click)="openPopup(true)">
              {{ 'Click here to login' | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
